import { AIError, errorResponseSchema } from './errors.js';
const loopbackHosts = ['localhost', '127.0.0.1', '[::1]'];
/**
 * Parses an AI API origin. HTTPS is required, except HTTP on loopback for
 * development; credentials, paths, queries and fragments are rejected.
 */
export function parseOrigin(value) {
    const origin = new URL(value);
    const isLoopback = loopbackHosts.includes(origin.hostname);
    const isSecure = origin.protocol === 'https:' || (origin.protocol === 'http:' && isLoopback);
    if (origin.username || origin.password || origin.search || origin.hash || origin.pathname !== '/' || !isSecure) {
        throw new Error('Use an HTTPS origin, or HTTP localhost for development.');
    }
    return origin;
}
/** Turns a non-OK AI API response and its parsed body into an AIError. */
export function readErrorResponse(response, body) {
    const parsed = errorResponseSchema.safeParse(body);
    const detail = parsed.success ? parsed.data : undefined;
    const retryAfter = Number(response.headers.get('retry-after'));
    const error = new AIError(detail?.error.message ?? 'AI request failed.', detail?.error.code ?? 'upstream_error', response.status, detail?.requestId, Number.isFinite(retryAfter) && retryAfter > 0 ? retryAfter : undefined);
    error.usage = detail?.usage;
    error.finishReason = detail?.finishReason;
    error.partialOutput = detail?.partialOutput;
    return error;
}
